import { render, staticRenderFns } from "./DisabledPagesGuard.vue?vue&type=template&id=073a365e"
import script from "./DisabledPagesGuard.vue?vue&type=script&lang=ts"
export * from "./DisabledPagesGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073a365e')) {
      api.createRecord('073a365e', component.options)
    } else {
      api.reload('073a365e', component.options)
    }
    module.hot.accept("./DisabledPagesGuard.vue?vue&type=template&id=073a365e", function () {
      api.rerender('073a365e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/guards/DisabledPagesGuard.vue"
export default component.exports